// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { Directions } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  directions: Directions
}} DrivingDirectionsPropsType */

/** @type { React.ValidationMap<DrivingDirectionsPropsType> } */
const propTypes = {
  directions: PropTypes.object.isRequired,
};

/** @type { StatelessComponent<DrivingDirectionsPropsType> } */
const DrivingDirections = ({ directions }) => {
  return (
    <div>
      <a
        href={`https://www.google.com/maps/dir/${directions.urlFriendlyOrigin}/${directions.urlFriendlyDestination}`}
        className="btn btn-success btn-large"
        target="_directions"
      >
        Google Directions
      </a>
      <ul className="recent-posts">
        <h5>Distance: {directions.distance}</h5>
        <h5>Time: {directions.duration}</h5>
        {directions.steps.map((step, idx) => (
          <li key={idx}>
            <span dangerouslySetInnerHTML={{ __html: step.html }} />
            <br />
            <span className="label label-info">{step.distance}</span>
            &nbsp;
            <span className="label label-success">{step.duration}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

DrivingDirections.displayName = 'DrivingDirections';
DrivingDirections.propTypes = propTypes;

export default DrivingDirections;
